import React, { useCallback, useEffect, useRef, useState } from 'react';
import notify from 'devextreme/ui/notify';
import { Button, FileUploader, LoadPanel, Lookup } from 'devextreme-react';
import * as ExcelJS from 'exceljs';
import axios from 'axios';
import GlobalParams from '../../helpers/GlobalParams';
import BulkGrid from '../BulkGrid/BulkGrid';
import joiner_template_path from '../../templates/joiner_template.xlsx';
import joiner_template_category_path from '../../templates/joiner_template_category.xlsx';
import supplimentary_template_path from '../../templates/supplimentary_template.xlsx';
import exits_template_path from '../../templates/exits_template.xlsx';
import paid_off_template_path from '../../templates/paid_off_template.xlsx';
import adjust_salary_template_path from '../../templates/adjust_salary_template.xlsx';
import loan_top_up_template_path from '../../templates/loan_top_up_template.xlsx';
import loan_term_top_up_template_path from '../../templates/loan_term_top_up_template.xlsx';
import joiner_template_last_expense from '../../templates/joiner_template _last_expense.xlsx';
import joiner_template_last_expense_cat from '../../templates/joiner_template _last_expense_cat.xlsx';
import moment from 'moment';

var filesData = null;
const UploadMembers = ({ onClosePopup, schemeStore }) => {
  const isValidDate = (dateStr) => {
    return moment(dateStr, 'DD/MM/YYYY', true).isValid();
  };
  const fileJoinerUploaderRef = useRef(null);
  const fileLoanTopUpUploaderRef = useRef(null);
  const fileRemovalUploaderRef = useRef(null);
  const fileAdjustSalaryUploaderRef = useRef(null);

  //const [schemeStore, setSchemeStore] = useState([]);
  const [isLastExpense, setIsLastExpense] = useState(false);
  const [is_with_categories, set_is_with_categories] = useState(false);
  const [isCreditLife, setIsCreditLife] = useState(false);
  const [lblJoinersBtn, setLblJoinersBtn] = useState("Download Joiners Template");
  const [lblUploadJoinersBtn, setLblUploadJoinersBtn] = useState("Upload Joiners");
  const [lblUploaderBtn, setLblUploaderBtn] = useState("Upload Joiners Excel File");

  const [lblRemovalBtn, setLblRemovalBtn] = useState("Download Removal Template");
  const [lblUploadRemovalBtn, setLblUploadRemovalBtn] = useState("Upload Removal");
  const [lblUploaderRemovalBtn, setLblUploaderRemovalBtn] = useState("Upload Removal Excel File");

  const [lblAdjustSalaryBtn, setLblAdjustSalaryBtn] = useState("Download Adjust Salary Template");
  const [lblUploadAdjustSalaryBtn, setLblUploadAdjustSalaryBtn] = useState("Upload Adjust Salary");
  const [lblUploaderAdjustSalaryBtn, setLblUploaderAdjustSalaryBtn] = useState("Upload Adjust Salary Excel File");

  const [loanTermTopUpFileContent, setLoanTermTopUpFileContent] = useState(null);
  const [joinersFileContent, setJoinersFileContent] = useState(null);
  const [removalFileContent, setRemovalFileContent] = useState(null);
  const [adjustFileContent, setAdjustFileContent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [SchemeId, setSchemeId] = useState(null);
  const [vsSchemeSelected, setVsSchemeSelected] = useState(false);
  const [BulksData, setBulksData] = useState([]);

  useEffect(() => {
    let tmpSchemeStore = [];
    if (GlobalParams.schemeStore && GlobalParams.schemeStore.length > 0) {
      tmpSchemeStore = GlobalParams.schemeStore.filter(scheme => (scheme.StatusCode === "001"));
    }

    if (tmpSchemeStore.length > 0) {
      //setSchemeStore(tmpSchemeStore);
    } else {
      //notify(`You don't have an active scheme to perform any servicing`, 'error', 5000);
    }
  }, []);

  const calculateAge = (birthDate) => {
    const currentDate = new Date();
    //const birthDateObj = new Date(birthDate);
    const birthDateObj = moment(birthDate, 'DD/MM/YYYY').toDate();

    let age = currentDate.getFullYear() - birthDateObj.getFullYear();

    // Check if the birthday has occurred for this year
    if (currentDate.getMonth() < birthDateObj.getMonth() ||
      (currentDate.getMonth() === birthDateObj.getMonth() && currentDate.getDate() < birthDateObj.getDate())) {
      age--;
    }

    return age;
  };

  const isDateInRange = (date_from, date_to, check_date) => {
    return check_date >= date_from && check_date <= date_to;
  }

  const validateDateOfBirth = (i, j, date) => {
    //let value = new Date(date);
    let value = moment(date, 'DD/MM/YYYY').toDate();
    //TODO - return either true or false
    if (value !== undefined && value !== null && value !== '') {
      console.log(value.toString());
      const age = calculateAge(value);

      var selectedDate = value;
      var currentDate = new Date();

      // Compare the selected date with the current date
      if (selectedDate > currentDate) {
        //notify('Future Date of Birth is not allowed', 'error', 5000);
        notify(`Future Date of Birth at is not allowed at column ${i}, row ${j} `, 'error', 5000);
        return false;
      }

      // if (age < 18 || age > 80) {
      //   // Clear the value if age is not within the range
      //   // You can also provide feedback to the user that the value is invalid
      //   notify(`Date of Birth must be between 18 and 80 years old at column ${i}, row ${j} `, 'error', 5000);
      //   return false;
      // }
    }
    return true;
  }

  const validateJoiningDate = (i, j, date) => {
    //let value = new Date(date);
    let value = moment(date, 'DD/MM/YYYY').toDate();
    //TODO - return either true or false
    if (value !== undefined && value !== null && value !== '') {
      //get the cover periods dates

      const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === SchemeId);

      // Assign the name to the variable 'ans'
      const DateFrom = SchemeDetails ? SchemeDetails.DateFrom : null;
      const End_date = SchemeDetails ? SchemeDetails.End_date : null;

      if (isDateInRange(new Date(DateFrom), new Date(End_date), new Date(value))) {
        console.log(new Date(value));
        return true;
      } else {
        notify(`Joining Date ${value} is Outside the cover period at column ${i}, row ${j} `, 'error', 5000);
        return false;
      }

    }
    return true;
  }

  const validateRelationship = (i, j, relationship) => {
    //TODO - return either true or false
    if (relationship === 'CH' || relationship === 'SP' || relationship === 'FH' ||
      relationship === 'MT' || relationship === 'BR' || relationship === 'SS' || relationship === null ||
      relationship === '' || relationship === undefined) {
      return true;
    }
    setIsLoading(false);
    notify(`${relationship} value at (Relationship) at column ${i}, row ${j} `, 'error', 5000);
    return false;
  }



  const validateJoinersExcel = async (e, file) => {
    try {

      if (file === null || file === undefined || file === "") {
        setIsLoading(false);
        console.log("Here at no file");
      } else {
        console.log("Here at validating");

        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(file);

        const worksheet = workbook.worksheets[0];
        //console.log(worksheet); // Log worksheet object
        const rowCount = worksheet.rowCount;
        //console.log(rowCount);

        // Validate number of columns
        const columnCount = worksheet.actualColumnCount;
        console.log(columnCount); // Log actual column count
        // Rest of your code...
        if (columnCount < 7) {
          setIsLoading(false);
          fileJoinerUploaderRef.current.instance.clear();
          notify(`Minimum expected columns is 6. Uploaded ${columnCount}`, "error", 5000);
          //e.component.clear();
          return;
        }

        // Validate data type of each column
        for (let i = 1; i <= columnCount; i++) {
          const columnValues = worksheet.getColumn(i).values;
          for (let j = 2; j <= rowCount; j++) { // Start from row 2 (assuming headers are in row 1)
            const value = columnValues[j];
            // Column 1 should be string - Staff No
            /*if (i === 1 && typeof value !== 'string') {
              setIsLoading(false);
              fileJoinerUploaderRef.current.instance.clear();
              notify(`Invalid data type in column 1 (Staff No) at row ${j}. Expected string.`, "error", 5000);
              return;
            }*/
            // Column 2 should be string - Name
            if (i === 2 && typeof value !== 'string') {
              setIsLoading(false);
              fileJoinerUploaderRef.current.instance.clear();
              notify(`Invalid data type in column 2 (Name) at row ${j}. Expected string.`, "error", 5000);
              return;
            }
            // Column 3 should be date - Birth Date
            if (i === 3) {
              if (!isValidDate(value)) {
                setIsLoading(false);
                fileJoinerUploaderRef.current.instance.clear();
                notify(`Invalid data type in column 3 (Birth Date) at row ${j}. Expected date.`, "error", 5000);
                return;
              }
              if (!validateDateOfBirth(i, j, value)) {
                setIsLoading(false);
                return;
              }
            }
            // Column 4 should be number - Age
            // if (i === 4 && isNaN(value)) {
            //   setIsLoading(false);
            //   fileJoinerUploaderRef.current.instance.clear();
            //   notify(`Invalid data type in column 4 (Age) at row ${j}. Expected number.`, "error", 5000);
            //   return;
            // }
            // Column 5 should be number - Annual Salary
            // if (i === 5 && isNaN(value)) {
            //   setIsLoading(false);
            //   fileJoinerUploaderRef.current.instance.clear();
            //   notify(`Invalid data type in column 5 (Annual Salary) at row ${j}. Expected number.`, "error", 5000);
            //   return;
            // }
            // Column 6 should be string - ID Number
            /*if (i === 6 && typeof value !== 'string') {
              notify(`Invalid data type in column 6 (ID Number) at row ${j}. Expected string.`, "error", 5000);
              return;
            }*/
            // Column 7 should be date - Joining Date
            if (i === 7) {
              if (!isValidDate(value)) {
                setIsLoading(false);
                fileJoinerUploaderRef.current.instance.clear();
                notify(`Invalid data type in column 3 (Joining Date) at row ${j}. Expected date.`, "error", 5000);
                return;
              }
              if (!validateJoiningDate(i, j, value)) {
                setIsLoading(false);
                return;
              }
            }
            //
            if (i === 10) {
              if (!validateRelationship(i, j, value)) {
                return;
              }
            }
          }
        }

        filesData = file;
        console.log(filesData);
        setJoinersFileContent(file);
        setIsLoading(false);
        notify("Excel file validated successfully.", "success", 5000);
      }
    } catch (error) {
      setIsLoading(false);
      fileJoinerUploaderRef.current.instance.clear();
      console.error("Error validating Excel file:", error);
      notify("Error validating Excel file. Please try again.", "error", 5000);
    }
  };

  const validateRemovalExcel = async (e, file) => {
    try {
      if (file === null || file === undefined || file === "") {
        setIsLoading(false);
        console.log("Here at no file");
      } else {
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(file);

        const worksheet = workbook.worksheets[0];
        console.log(worksheet); // Log worksheet object
        const rowCount = worksheet.rowCount;

        // Validate number of columns
        const columnCount = worksheet.actualColumnCount;
        console.log(columnCount); // Log actual column count
        // Rest of your code...
        if (columnCount !== 3) {
          setIsLoading(false);
          fileRemovalUploaderRef.current.instance.clear();
          notify(`Expected columns are 3. Uploaded ${columnCount}`, "error", 5000);
          return;
        }

        // Validate data type of each column
        for (let i = 1; i <= columnCount; i++) {
          const columnValues = worksheet.getColumn(i).values;
          for (let j = 2; j <= rowCount; j++) { // Start from row 2 (assuming headers are in row 1)
            const value = columnValues[j];
            // Column 1 should be string - Staff No
            /*if (i === 1 && typeof value !== 'string') {
              setIsLoading(false);
              fileRemovalUploaderRef.current.instance.clear();
              notify(`Invalid data type in column 1 at row ${j}. Expected string.`, "error", 5000);
              return;
            }*/
            // Column 2 should be string - Name
            if (i === 2 && typeof value !== 'string') {
              setIsLoading(false);
              fileRemovalUploaderRef.current.instance.clear();
              notify(`Invalid data type in column 2 at row ${j}. Expected string.`, "error", 5000);
              return;
            }
            // Column 2 should be date - Exit Date
            if (i === 3) {
              if (!isValidDate(value)) {
                setIsLoading(false);
                fileRemovalUploaderRef.current.instance.clear();
                notify(`Invalid data type in column 3 at row ${j}. Expected date.`, "error", 5000);
                return;
              }
              if (!validateJoiningDate(i, j, value)) {
                return;
              }
            }
          }
        }

        filesData = file;
        setRemovalFileContent(file);
        notify("Excel file validated successfully.", "success", 5000);
      }

    } catch (error) {
      console.error("Error validating Excel file:", error);
      notify("Error validating Excel file. Please try again.", "error", 5000);
    }
  };

  const validateAdjustExcel = async (e, file) => {
    try {
      if (file === null || file === undefined || file === "") {
        setIsLoading(false);
        console.log("Here at no file");
      } else {
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(file);

        const worksheet = workbook.worksheets[0];
        console.log(worksheet); // Log worksheet object
        const rowCount = worksheet.rowCount;

        // Validate number of columns
        const columnCount = worksheet.actualColumnCount;
        console.log(columnCount); // Log actual column count
        // Rest of your code...

        if (columnCount !== 4) {
          setIsLoading(false);
          fileAdjustSalaryUploaderRef.current.instance.clear();
          notify(`Expected columns are 4. Uploaded ${columnCount}`, "error", 5000);
          return;
        }

        // Validate data type of each column
        for (let i = 1; i <= columnCount; i++) {
          const columnValues = worksheet.getColumn(i).values;
          for (let j = 2; j <= rowCount; j++) { // Start from row 2 (assuming headers are in row 1)
            const value = columnValues[j];
            // Column 1 should be string - Staff No
            /*if (i === 1 && typeof value !== 'string') {
              setIsLoading(false);
              fileAdjustSalaryUploaderRef.current.instance.clear();
              notify(`Invalid data type in column 1 (Staff No) at row ${j}. Expected string.`, "error", 5000);
              return;
            }*/
            // Column 2 should be string - Name
            if (i === 2 && typeof value !== 'string') {
              setIsLoading(false);
              fileAdjustSalaryUploaderRef.current.instance.clear();
              notify(`Invalid data type in column 2 (Name) at row ${j}. Expected string.`, "error", 5000);
              return;
            }
            // Column 3 should be date - Effective Date
            if (i === 3) {
              if (!isValidDate(value)) {
                setIsLoading(false);
                fileAdjustSalaryUploaderRef.current.instance.clear();
                notify(`Invalid data type in column 3 (Effective Date) at row ${j}. Expected date.`, "error", 5000);
                return;
              }
              if (!validateJoiningDate(i, j, value)) {
                return;
              }
            }
            // Column 4 should be number - Annual Salary
            if (i === 4 && isNaN(value)) { //
              setIsLoading(false);
              fileAdjustSalaryUploaderRef.current.instance.clear();
              notify(`Invalid data type in column 4 (Annual Salary) at row ${j}. Expected number.`, "error", 5000);
              return;
            }
          }
        }

        filesData = file;
        setAdjustFileContent(file);
        notify("Excel file validated successfully.", "success", 5000);
      }
    } catch (error) {
      console.error("Error validating Excel file:", error);
      notify("Error validating Excel file. Please try again.", "error", 5000);
    }
  };


  const handleJoinersFileUploaded = (e) => {
    if (e.value !== null && e.value !== undefined && e.value !== "") {
      const file = e.value[0];
      if (!isCreditLife) {
        setIsLoading(true);
        console.log("No file selected");
        validateJoinersExcel(e, file);
      } else {
        //assign the file...
        setJoinersFileContent(file);
        setIsLoading(false);
        notify("Excel file validated successfully.", "success", 5000);
      }
    }
  };

  const handleLoanTopUpFileUploaded = (e) => {
    if (e.value !== null && e.value !== undefined && e.value !== "") {
      const file = e.value[0];
      // if (!isCreditLife) {
      //   setIsLoading(true);
      //   console.log("No file selected");
      //   validateJoinersExcel(e, file);
      // } else{
      //assign the file...
      setLoanTermTopUpFileContent(file);
      setIsLoading(false);
      notify("Excel file validated successfully.", "success", 5000);
      //}

    }
  };

  const handleRemovalFileUploaded = (e) => {
    if (e.value !== null && e.value !== undefined && e.value !== "") {
      const file = e.value[0];
      if (!isCreditLife) {
        validateRemovalExcel(e, file);
      } else {
        setRemovalFileContent(file);
        notify("Excel file validated successfully.", "success", 5000);
      }

    }
  }

  const handleAdjustFileUploaded = (e) => {
    if (e.value !== null && e.value !== undefined && e.value !== "") {
      const file = e.value[0];
      if (!isCreditLife) {
        validateAdjustExcel(e, file);
      } else {
        setAdjustFileContent(file);
        notify("Excel file validated successfully.", "success", 5000);
      }
    }
  }

  const postFiles = async (endorsement_type, request_change, file_data) => {
    try {
      let post_data = {
        'portal_user_id': GlobalParams.ContactPersonId,
        'scheme_id': SchemeId,
        'endorsement_type': endorsement_type,
        'effective_date': new Date(),
        'requested_change': request_change,
        'file': file_data
      };


      console.log(post_data);
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "client-with-multiple-endo-members",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      //console.log(result.data.request_id);
      //if (result.status === 200) {
      setIsLoading(false);
      postAutomate(result.data.data.request_id, post_data.scheme_id);
      notify(result.data.message, 'success', 5000);
      if (endorsement_type === '2') {
        fileJoinerUploaderRef.current.instance.clear();
      } else if (endorsement_type === '3' || endorsement_type === '8') {
        fileRemovalUploaderRef.current.instance.clear();
      } else if (endorsement_type === '6' || endorsement_type === '7') {
        fileAdjustSalaryUploaderRef.current.instance.clear();
        //if (fileLoanTopUpUploaderRef != null && fileLoanTopUpUploaderRef !== undefined) {
          fileLoanTopUpUploaderRef.current.instance.clear();
        //}
      }

      setIsLoading(true);
      getBulkUploads(SchemeId);
      //onClosePopup();
      
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postSchemeBalance = async (scheme_id) => {
    try {

      let post_data = {
        'scheme_id': scheme_id
      };
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "recalculate-scheme-balance",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postDebits = async (scheme_id) => {
    try {

      let post_data = {
        'scheme_id': scheme_id
      };
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "post-debits-to-gl",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      postSchemeBalance(scheme_id);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const postAutomate = async (request_id, scheme_id) => {
    try {

      let post_data = {
        'request_id': request_id
      };
      console.log(post_data);
      const result = await axios.post(
        GlobalParams.ApiUrlPrefix + "get-endorsements-processing-results",
        post_data,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken, // Include bearer token in the Authorization header
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      postDebits(scheme_id);
      //console.log(result.data.request_id);
      console.log("Automation Request finished");
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  const getBulkUploads = async (scheme_id) => {
    try {
      const result = await axios.get(
        GlobalParams.ApiUrlPrefix + "get-endorsement-requests?scheme_id=" + scheme_id,
        {
          headers: {
            'Authorization': 'Bearer ' + GlobalParams.bearerToken // Include bearer token in the Authorization header
          }
        }
      );
      setIsLoading(false);

      if(result.status === 200){
        let tmp_BulksData = result.data.data;
        //TODO filter  tmp_BulksData to only where 'bulk_upload' = 1
        tmp_BulksData = tmp_BulksData.filter(item => item.bulk_upload === 1 || item.bulk_upload === '1');
        setBulksData(tmp_BulksData);
      }
      

    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify(error.response.data.message, 'error', 5000);
    }
  };

  return (
    <div>
      <LoadPanel visible={isLoading} />
      <div>
        <Lookup
          dataSource={schemeStore}
          displayExpr="PolicyCompany"
          valueExpr="schemeID"
          placeholder="Select Scheme"
          onValueChanged={(e) => {
            if (e.value !== null && e.value !== undefined && e.value !== "" && e.value !== 0) {

              const SchemeDetails = GlobalParams.schemeStore.find(item => item.schemeID === e.value);
              //TODO - Check if its last expense and check if its with_categories
              set_is_with_categories(false);
              setIsLastExpense(false);
              if (SchemeDetails.class_code === "5") {
                setIsLastExpense(true);
              }
              if (SchemeDetails.with_categories === "1") {
                set_is_with_categories(true);
              }


              if (SchemeDetails.IsCreditLifeCover === "1") {
                setIsCreditLife(true);
                //TODO - change the labels...
                setLblJoinersBtn("Download New Loan Template");
                setLblUploadJoinersBtn("Upload New Loan");
                setLblUploaderBtn("Upload New Loan Excel File");

                setLblRemovalBtn("Download Early Settlement Refund Template");
                setLblUploadRemovalBtn("Upload Early Settlement Refund");
                setLblUploaderRemovalBtn("Upload Early Settlement Refund Excel File");

                setLblAdjustSalaryBtn("Download Loan Top up Template");
                setLblUploadAdjustSalaryBtn("Upload Loan Top up");
                setLblUploaderAdjustSalaryBtn("Upload Loan Top up Excel File");
              } else {
                setIsCreditLife(false);
                //TODO - change the labels...
                setLblJoinersBtn("Download Joiners Template");
                setLblUploadJoinersBtn("Upload Joiners");
                setLblUploaderBtn("Upload Joiners Excel File");

                setLblRemovalBtn("Download Removal Template");
                setLblUploadRemovalBtn("Upload Removal");
                setLblUploaderRemovalBtn("Upload Removal Excel File");

                setLblAdjustSalaryBtn("Download Adjust Salary Template");
                setLblUploadAdjustSalaryBtn("Upload Adjust Salary");
                setLblUploaderAdjustSalaryBtn("Upload Adjust Salary Excel File");
              }

              setSchemeId(e.value);
              setVsSchemeSelected(true);
              //get the bulk uploads...
              setIsLoading(true);
              getBulkUploads(e.value);
            } else {
              setVsSchemeSelected(false);
            }
          }}
        />
        {/*<div>
          Selected Scheme: {SchemeId}
        </div>*/}
      </div>
      <br></br>
      <section className="row">
        <div className="col-md-4">
          <Button
            type='danger'
            text={lblJoinersBtn}
            icon='download'
            visible={vsSchemeSelected}
            onClick={
              () => {
                let download_path = joiner_template_path;
                let download_filename = 'joiner_template.xlsx';
                if (is_with_categories) {
                  download_path = joiner_template_category_path;
                  download_filename = 'joiner_template.xlsx';
                }
                if (isCreditLife) {
                  download_path = supplimentary_template_path;
                  download_filename = "supplimentary_template.xlsx";
                } else {
                  if (isLastExpense) {
                    download_path = joiner_template_last_expense;
                    download_filename = 'joiner_template _last_expense .xlsx';
                    if (is_with_categories) {
                      download_path = joiner_template_last_expense_cat;
                      download_filename = 'joiner_template_last_expense_cat.xlsx';
                    }
                  } 
                }
                // Fetch the file
                fetch(download_path)
                  .then(response => response.blob()) // Convert the response to a Blob
                  .then(blob => {
                    // Convert the Blob to Base64
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onload = () => {
                      // Create a temporary anchor element
                      const anchor = document.createElement('a');
                      anchor.href = reader.result; // Set the href to the Base64 data URL
                      anchor.download = download_filename; // Set the filename for download
                      anchor.click(); // Trigger the download
                    };
                  })
                  .catch(error => console.error('Error fetching the file:', error));
              }
            }
          />
          <FileUploader
            ref={fileJoinerUploaderRef}
            visible={vsSchemeSelected}
            accept=".xlsx"
            labelText={lblUploaderBtn}
            uploadMode="useForm"
            onValueChanged={handleJoinersFileUploaded}
          />
          <Button
            visible={vsSchemeSelected}
            disabled={!joinersFileContent}
            type='default'
            text={lblUploadJoinersBtn}
            icon='upload'
            onClick={(e) => {
              if (joinersFileContent) {
                console.log(filesData);
                // Perform upload action here if needed
                let endorse_type = '2';
                let msg = 'Bulk Joiners';
                if (isCreditLife) {
                  endorse_type = '8';
                  msg = "New Loan";
                }
                setIsLoading(true);
                postFiles(endorse_type, msg, filesData);
              }
            }}
          />
        </div>
        <div className="col-md-4">
          <Button
            visible={vsSchemeSelected}
            type='danger'
            text={lblRemovalBtn}
            icon='download'
            onClick={
              () => {
                let download_path = exits_template_path;
                let download_filename = 'exits_template.xlsx';
                if (isCreditLife) {
                  download_path = supplimentary_template_path;
                  download_filename = 'paid_off_template.xlsx';
                }
                // Fetch the file
                fetch(download_path)
                  .then(response => response.blob()) // Convert the response to a Blob
                  .then(blob => {
                    // Convert the Blob to Base64
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onload = () => {
                      // Create a temporary anchor element
                      const anchor = document.createElement('a');
                      anchor.href = reader.result; // Set the href to the Base64 data URL
                      anchor.download = download_filename; // Set the filename for download
                      anchor.click(); // Trigger the download
                    };
                  })
                  .catch(error => console.error('Error fetching the file:', error));
              }
            }
          />
          <FileUploader
            ref={fileRemovalUploaderRef}
            visible={vsSchemeSelected}
            accept=".xlsx"
            labelText={lblUploaderRemovalBtn}
            uploadMode="useForm"
            onValueChanged={handleRemovalFileUploaded}
          />
          <Button
            visible={vsSchemeSelected}
            disabled={!removalFileContent}
            icon='upload'
            type='default'
            text={lblUploadRemovalBtn}
            onClick={() => {
              if (removalFileContent) {
                // Perform upload action here if needed
                let endorse_type = '3';
                let msg = 'Bulk Exits';
                if (isCreditLife) {
                  endorse_type = '8';
                  msg = "Early Settlement Refund";
                }
                setIsLoading(true);
                postFiles(endorse_type, msg, filesData);
              }
            }}
          />
        </div>
        <div className="col-md-4">
          <Button
            visible={vsSchemeSelected}
            type='danger'
            text={lblAdjustSalaryBtn}
            icon='download'
            onClick={
              () => {
                let download_path = adjust_salary_template_path;
                let download_filename = 'adjust_salary_template.xlsx';
                if (isCreditLife) {
                  download_path = loan_top_up_template_path;
                  download_filename = 'loan_top_up_template.xlsx';
                }
                // Fetch the file
                fetch(download_path)
                  .then(response => response.blob()) // Convert the response to a Blob
                  .then(blob => {
                    // Convert the Blob to Base64
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onload = () => {
                      // Create a temporary anchor element
                      const anchor = document.createElement('a');
                      anchor.href = reader.result; // Set the href to the Base64 data URL
                      anchor.download = download_filename; // Set the filename for download
                      anchor.click(); // Trigger the download
                    };
                  })
                  .catch(error => console.error('Error fetching the file:', error));
              }
            }
          />
          <FileUploader
            ref={fileAdjustSalaryUploaderRef}
            visible={vsSchemeSelected}
            accept=".xlsx"
            labelText={lblUploaderAdjustSalaryBtn}
            uploadMode="useForm"
            onValueChanged={handleAdjustFileUploaded}
          />
          <Button
            visible={vsSchemeSelected}
            disabled={!adjustFileContent}
            text={lblUploadAdjustSalaryBtn}
            type='default'
            icon='upload'
            onClick={() => {
              if (adjustFileContent) {
                let endorse_type = '6';
                let msg = 'Bulk Adjust Salary';
                if (isCreditLife) {
                  endorse_type = '7';
                  msg = "Loan Amount Extension";
                }
                // Perform upload action here if needed
                setIsLoading(true);
                postFiles(endorse_type, msg, filesData);
              }
            }}
          />
        </div>
      </section>
      <hr></hr>
      <br></br>
      {isCreditLife &&
        <section className="row">
          <div className="col-md-4">
            <Button
              type='danger'
              text={'Loan Term Extension'}
              icon='download'
              visible={isCreditLife}
              onClick={
                () => {
                  let download_path = loan_term_top_up_template_path;
                  let download_filename = 'loan_term_extension_template.xlsx';
                  // Fetch the file
                  fetch(download_path)
                    .then(response => response.blob()) // Convert the response to a Blob
                    .then(blob => {
                      // Convert the Blob to Base64
                      const reader = new FileReader();
                      reader.readAsDataURL(blob);
                      reader.onload = () => {
                        // Create a temporary anchor element
                        const anchor = document.createElement('a');
                        anchor.href = reader.result; // Set the href to the Base64 data URL
                        anchor.download = download_filename; // Set the filename for download
                        anchor.click(); // Trigger the download
                      };
                    })
                    .catch(error => console.error('Error fetching the file:', error));
                }
              }
            />
            <FileUploader
              ref={fileLoanTopUpUploaderRef}
              visible={isCreditLife}
              accept=".xlsx"
              labelText={'Upload Loan Term Extension Excel File'}
              uploadMode="useForm"
              onValueChanged={handleLoanTopUpFileUploaded}
            />
            <Button
              visible={isCreditLife}
              disabled={!loanTermTopUpFileContent}
              type='default'
              text={'Upload Loan Term Extension'}
              icon='upload'
              onClick={(e) => {
                //if (joinersFileContent) {
                console.log(filesData);
                // Perform upload action here if needed
                setIsLoading(true);
                postFiles('7', 'Loan Term Extension', filesData);
                //}
              }}
            />
          </div>
        </section>
      }
      <br></br>
      <div >
        <BulkGrid BulksData={BulksData} />
      </div>
    </div>
  );
};

export default UploadMembers;